module.exports = __webpack_public_path__ + "static/media/workplace.8379f48d.svg";